<template>
<div>


  <v-row class="ma-2">
    <v-col cols="12" lg="4" @click="gotoPageByWidget('widget1')">
      <material-chart-card class="mt-10"
                       :data="widget1.data"
                       :options="widget1.options"
                       color="info"
                       hover-reveal
                       type="Bar"
  >

    <h4 class="card-title font-weight-light mt-2 ml-2">
      Заявки на приемку
    </h4>

    <p class="d-inline-flex font-weight-light ml-2 mt-1">
      Принятых заявок на приемку за последние {{dayDeep}} дн.
    </p>

    <template v-slot:actions>
      <v-icon
          class="mr-1"
          small
      >
        mdi-clock-outline
      </v-icon>
      <span class="caption grey--text font-weight-light">обновлено 10 минут назад</span>
    </template>

  </material-chart-card>
    </v-col>

    <v-col cols="12" lg="4" @click="gotoPageByWidget('widget2')">
      <material-chart-card class="mt-10"
                       :data="widget2.data"
                       :options="widget2.options"
                       color="info"
                       hover-reveal
                       type="Bar"
  >

    <h4 class="card-title font-weight-light mt-2 ml-2">
      Заявки на отгрузку
    </h4>

    <p class="d-inline-flex font-weight-light ml-2 mt-1">
      Принятых заявок на отгрузку за последние {{dayDeep}} дн.
    </p>

    <template v-slot:actions>
      <v-icon
          class="mr-1"
          small
      >
        mdi-clock-outline
      </v-icon>
      <span class="caption grey--text font-weight-light">обновлено 10 минут назад</span>
    </template>

  </material-chart-card>
    </v-col>

    <v-col cols="12" lg="4" @click="gotoPageByWidget('widget3')">
      <material-chart-card class="mt-10"
                       :data="widget3.data"
                       :options="widget3.options"
                       color="info"
                       hover-reveal
                       type="Bar"
  >

    <h4 class="card-title font-weight-light mt-2 ml-2">
      Загрузка номенклатурного справочника
    </h4>

    <p class="d-inline-flex font-weight-light ml-2 mt-1">
      Обновления за последние {{dayDeep}} дн.
    </p>

    <template v-slot:actions>
      <v-icon
          class="mr-1"
          small
      >
        mdi-clock-outline
      </v-icon>
      <span class="caption grey--text font-weight-light">обновлено 10 минут назад</span>
    </template>

  </material-chart-card>
    </v-col>

    <v-col cols="12" md="12" class="mt-8" @click="gotoPageByWidget('widget4')">
      <material-card color="info" class="px-5 py-3">
        <template v-slot:heading>
          <div class="display-2 font-weight-light">
            Входящие сообщения
          </div>

          <div class="subtitle-1 font-weight-light">
            Непрочитанных сообщений: 0
          </div>
        </template>
        <v-card-text>
          <v-data-table
              :headers="messageHeaders"
              :items="getMessages"
          >
            <template v-slot:[`item.files`]="{ item }">
              <v-icon small class="mr-2" v-if="item.files.length>0">
                mdi-paperclip
              </v-icon>
            </template>

          </v-data-table>
        </v-card-text>
      </material-card>
    </v-col>

  </v-row>





</div>

</template>

<script>

import MaterialChartCard from "@/components/MaterialChartCard.vue";
import MaterialCard from "@/components/MaterialCard.vue";
import { mapGetters, mapMutations } from "vuex"
export default {
	name: "MainPage",
  components:{
    MaterialCard, MaterialChartCard
    // DashboardCard07
  },
	data() {
		return {
      startDate: new Date(),
      endDate: new Date(),
      messageHeaders: [
        { text: 'Дата', value: 'date' },
        { text: 'Тема', value: 'subject' },
        { text: 'Локация', value: 'location' },
        { text: 'Статус', value: 'status' },
        { text: 'Вложения', value: 'files' },
      ],
      dayDeep: 14,
    }
	},
	methods: {
    ...mapMutations('app',["setCurrentTicketTab"]),

    async openNotes(){
      //https://subtitletools.com/convert-text-files-to-utf8-online
      const result = await this.appRefs.DialogInfoWeb.show({
        title: "Памятка по работе в личном кабинете",
        src: `/static/Памятка%20о%20порядке%20работы.htm`,
        positiveTitle: "Ознакомился",
      });
      console.log(result)

    },

    gotoPageByWidget(widget){
      console.log(widget)
      switch (widget){
        case 'widget1':
          this.setCurrentTicketTab(0)
          this.$router.push({ name: "MyTicketsPage" })
          break;
        case 'widget2':
          this.setCurrentTicketTab(1)
          this.$router.push({ name: "MyTicketsPage" })
          break;
        case 'widget3':
          this.setCurrentTicketTab(2)
          this.$router.push({ name: "MyTicketsPage" })
          break;
        case 'widget4':
          this.$router.push({ name: "MyInboxPage" })
          break;
        default:
          break;
      }
    },

    createArrayPeriod(from, to){
      const arr = []
      for (const day = from; day <= to; day.setDate(day.getDate() + 1)) {
        arr.push(
            { date: day,
              title: day.getDate(),
              hash: `${day.getFullYear()}${day.getMonth()<9?'0':''}${day.getMonth()+1}${day.getDate()}`,
              value: 0})
      }
      return arr;
    }
	},
	watch: {
	},
	computed: {
    ...mapGetters('app',["getTickets", "getMessages"]),

    // messageItems(){
    //   return []
    // },

    widget1() {
      this.startDate.setDate(this.endDate.getDate() - this.dayDeep);
      const data = this.createArrayPeriod(this.startDate, this.endDate)
      const tickets = this.getTickets.filter(element => element.ticketType === "ЗаявкаНаПриемку").map(item=>{
        const day = new Date(item.date);
        return `${day.getFullYear()}${day.getMonth()<9?'0':''}${day.getMonth()+1}${day.getDate()}`
      })
       data.forEach((item, idx)=>{
         // eslint-disable-next-line no-unused-vars
         tickets.filter(value=>value===item.hash).forEach(res=>{
           data[idx].value = data[idx].value + 1
         })
       })
      return {
          data: {
            labels: data.map(item=>item.title),
            series: [
                data.map(item=>item.value),
            ],
          },
          options: {axisX: {showGrid: false,},
            chartPadding: {top: 0, right: 5, bottom: 0, left: 0,},
          }
      }
    },

    widget2() {
      this.startDate.setDate(this.endDate.getDate() - this.dayDeep);
      const data = this.createArrayPeriod(this.startDate, this.endDate)
      const tickets = this.getTickets.filter(element => element.ticketType === "ЗаявкаНаОтгрузку").map(item=>{
        const day = new Date(item.date);
        return `${day.getFullYear()}${day.getMonth()<9?'0':''}${day.getMonth()+1}${day.getDate()}`
      })
      data.forEach((item, idx)=>{
        // eslint-disable-next-line no-unused-vars
        tickets.filter(value=>value===item.hash).forEach(res=>{
          data[idx].value = data[idx].value + 1
        })
      })
      return {
        data: {
          labels: data.map(item=>item.title),
          series: [
            data.map(item=>item.value),
          ],
        },
        options: {axisX: {showGrid: false,},
          chartPadding: {top: 0, right: 5, bottom: 0, left: 0,},
        }
      }
    },

    widget3() {
      this.startDate.setDate(this.endDate.getDate() - this.dayDeep);
      const data = this.createArrayPeriod(this.startDate, this.endDate)
      const tickets = this.getTickets.filter(element => element.ticketType === "ЗагрузкаСправочников").map(item=>{
        const day = new Date(item.date);
        return `${day.getFullYear()}${day.getMonth()<9?'0':''}${day.getMonth()+1}${day.getDate()}`
      })
      data.forEach((item, idx)=>{
        // eslint-disable-next-line no-unused-vars
        tickets.filter(value=>value===item.hash).forEach(res=>{
          data[idx].value = data[idx].value + 1
        })
      })
      return {
        data: {
          labels: data.map(item=>item.title),
          series: [
            data.map(item=>item.value),
          ],
        },
        options: {axisX: {showGrid: false,},
          chartPadding: {top: 0, right: 5, bottom: 0, left: 0,},
        }
      }
    },


  },

	created() {
  },
  inject:['appRefs']
}
</script>
